import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store'
import Cookies from 'js-cookie'
import userRules from '@/api/userRules'
import getOnboardingInfos from '@/api/getOnboardingInfos';
import getAllCnpjs from '@/api/getAllCnpjs';
import getNotifications from '@/api/getNotifications';
import getNotificationBilling from '@/api/getNotificationBilling';
import getUserData from '@/api/getUserData';

import signinRouter from './modules/signin';
import forgotRouter from './modules/forgot';
import signupRouter from './modules/signup';
import providerRouter from './modules/provider';
import buyerRouter from './modules/buyer';
import buyersRouter from './modules/buyers';
import sponsorRouter from './modules/sponsor';
import companyRouter from './modules/company';
import partnerRouter from './modules/partner';
import userRouter from './modules/user';
import profileRouter from './modules/profile';
import groupRouter from './modules/group';
import partnersRouter from './modules/partners';
import bankRouter from './modules/bank';
import myCompanyRouter from './modules/myCompany';
import { newCompany, newCompanyRegister, selectCompany, logout, privacyPolicy, mobileAlert, termsOfUse, newGroupCompany, newSponsorPartner, unsubscribe} from './modules/notSidebar'
import getWhiteLabel from '@/utils/getWhiteLabel';

import jwt_decode from 'jwt-decode'
import { WHITELABEL } from '../utils/constants';


Vue.use(Router);

const router = new Router({
    mode: 'history',
    routes: [
        signinRouter,
        forgotRouter,
        signupRouter,
        providerRouter,
        buyerRouter,
        buyersRouter,
        sponsorRouter,
        companyRouter,
        partnerRouter,
        userRouter,
        profileRouter,
        newCompany,
        newCompanyRegister,
        newGroupCompany,
        newSponsorPartner,
        selectCompany,
        groupRouter,
        partnersRouter,
        bankRouter,
        logout,
        myCompanyRouter,
        privacyPolicy,
        mobileAlert,
        termsOfUse,
        unsubscribe,
        { path: '*', redirect: '/', hidden: true },
    ],
});

router.afterEach((to) => {
    document.title = to.meta.title || `${getWhiteLabel()} | APP`;
});

router.beforeEach(async(to, from, next) => {
    const { acceptedRoutes } = store.state.creditAntecipation
    store.commit('creditAntecipation/setCurrentRoute', acceptedRoutes.HOME)
    store.commit('creditAntecipation/setCurrentDeadlineNumber', 150)
    store.commit('creditAntecipation/clearRemovedPortions')
    store.commit('creditAntecipation/clearPortions')
    store.commit('creditAntecipation/clearXmlPortionsWithoutXml')
    store.commit('creditAntecipation/clearXmlPortionsWithXml')
    store.commit('creditAntecipation/clearDateRange')
    store.commit('creditAntecipation/resetSelectedPortions')
    store.commit('creditAntecipation/clearAutoOffers')
    store.commit('creditAntecipation/clearCreditLimits')
    
    if(window.location.href.match("brr-credito")) window.location.replace("https://fundomultisupermercados-account.cashforce.com.br");
   
    if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        if(to.name != 'mobile'){ 
            next({ name: 'mobile' })
        }
       }
    let token = Cookies.get('token');
    let profile = Cookies.get('selectedProfile');
    if (token) {
        const tokenContent = jwt_decode(token)
        const whitelabel = getWhiteLabel(true)

        const { partner } = tokenContent
        
        if (!partner) {
            next()
        }
        if (tokenContent.partner.toLowerCase().replace(/[ .]/g, '') !== whitelabel) {
            // RESETA OS COOKIES
            Cookies.remove('selectedCompany', { domain: process.env.VUE_APP_ROOT_DOMAIN })
            Cookies.remove('token', { domain: process.env.VUE_APP_ROOT_DOMAIN })
            Cookies.remove('companyInfo', { domain: process.env.VUE_APP_ROOT_DOMAIN })
            Cookies.remove('userInfo', { domain: process.env.VUE_APP_ROOT_DOMAIN })
            Cookies.remove('keepConnected', { domain: process.env.VUE_APP_ROOT_DOMAIN })
            window.location = WHITELABEL[whitelabel].urls.CLIENT
            return 
        }

    }
    if (token && !store.state.user.token || store.state.user.token != token) {
        if (!token) {
            next()
        }
        store.commit('user/setToken', token)
        await getAllCnpjs()
        await userRules()
        store.commit('user/setProfile', profile)
        window.location.reload();
    }
    if (!to.meta.requiresAuth) {
        next()
    } else {

        if (store.state.user.token) {
            if (!store.state.user.infos.name) {
                await getUserData(store.state.user.token)
            }
            getNotifications()
            getNotificationBilling()
            getOnboardingInfos()
            next()
        } else {
            router.push('/logout')
        }
    }
})

export default router;